import { STORE_MODULE_NAME } from "./permissionStoreModule";
import get from "lodash.get";

export default function usePermission() {

  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`



  const actionResolver = (input) => {
    const actions = [
        {
            input: "add",
            output: "создание",
        },
        {
            input: "change",
            output: "модификация"
        },
        {
            input: "delete",
            output: "удаление"
        },
        {
            input: "view",
            output: "чтение"
        },
    ]
    return get(actions.filter(action => action.input === input), "[0]['output']")
  }


  return {
    fetchDataUrl,
    actionResolver,
  }
}
